/**
 * Isomorf lagring för SEO-överskrivningar från adminpanelen (tabellen seo_meta).
 *
 * På servern fylls den av en request-middleware innan routing (se src/start.ts)
 * så att `seoHead()` kan läsa värdena synkront vid SSR. I webbläsaren fylls den
 * av `useSeoOverrides()` som hämtar samma rader via Data API:et.
 */

export interface SeoOverride {
  path: string;
  title?: string | null;
  description?: string | null;
  og_image?: string | null;
  noindex?: boolean | null;
}

let overrides = new Map<string, SeoOverride>();
let loadedAt = 0;

const normalize = (path: string) => {
  const p = (path || "/").split("?")[0]?.split("#")[0] ?? "/";
  const trimmed = p.replace(/\/+$/, "");
  return trimmed === "" ? "/" : trimmed.toLowerCase();
};

export function setSeoOverrides(rows: SeoOverride[]): void {
  overrides = new Map(rows.map((r) => [normalize(r.path), r]));
  loadedAt = Date.now();
}

export function seoOverridesLoadedAt(): number {
  return loadedAt;
}

export function getSeoOverride(path: string): SeoOverride | undefined {
  return overrides.get(normalize(path));
}

/** Alla laddade överskrivningar (används för att skicka med dem till webbläsaren). */
export function allSeoOverrides(): SeoOverride[] {
  return Array.from(overrides.values());
}

// I webbläsaren: läs in de överskrivningar som servern skickade med i HTML:en,
// så att head() räknar fram samma titel vid hydrering som vid SSR.
if (typeof window !== "undefined") {
  const seeded = (window as unknown as { __SEO_OVERRIDES__?: SeoOverride[] }).__SEO_OVERRIDES__;
  if (Array.isArray(seeded) && seeded.length > 0) setSeoOverrides(seeded);
}
